import { useSearchParams } from 'react-router-dom';
import { ConversationFilterIds } from '../constants/enums';
import { ConversationColumnFilter } from '../types/ConversationTableFilter';
import { isNotNull } from 'core/utils/isNotNull';
import { formatSearchParamValue } from 'utils/fomatting';
import { getConversationFilterLabel } from '../utils/getConversationFilterLabel';

/** Restores column filters from the URL, so a shared link opens filtered. */
export const useConversationInitialFilters = (): ConversationColumnFilter[] => {
  const [searchParams] = useSearchParams();

  const toFilter = (
    filterId: ConversationFilterIds
  ): ConversationColumnFilter | null => {
    const rawValue = searchParams.get(filterId);

    if (!isNotNull(rawValue)) {
      return null;
    }

    return {
      filterId,
      value: formatSearchParamValue(rawValue),
      label: getConversationFilterLabel(filterId, rawValue)
    };
  };

  return Object.values(ConversationFilterIds).map(toFilter).filter(isNotNull);
};
